// Auto-évaluations — lot A : déterminants majeurs enseignés en classe (10 questions chacun).
const Q = (q, options, correct, explanation) => ({ q, options, correct, explanation });

export const QUIZZES_A = {
  avc_suspecte: {
    title: 'Auto-évaluation — AVC suspecté',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Que signifie l’échelle VITE ?',
        ['Ventilation, Immobilité, Température, Éveil', 'Visage, Incapacité (bras), Trouble de la parole, Extrême urgence', 'Vision, Infection, Tremblements, Épuisement', 'Vitesse, Intensité, Temps, Évaluation'], 1,
        'VITE (FAST en anglais) : un seul signe positif = urgence extrême.'),
      Q('Quelle phrase faites-vous répéter pour tester l’élocution ?',
        ['« Bonjour, comment ça va ? »', '« Le ciel est bleu à Cincinnati »', '« Un chasseur sachant chasser »', 'Aucune — on n’évalue pas la parole'], 1,
        'Le test d’élocution enseigné : paroles embrouillées = signe positif.'),
      Q('Quelle information temporelle est CRUCIALE ?',
        ['L’heure du réveil', 'L’heure du DERNIER moment où le patient était normal', 'L’heure du dernier repas', 'L’heure de l’appel'], 1,
        'Elle détermine l’admissibilité à la thrombolyse. « Ce matin » ne suffit pas.'),
      Q('La famille veut donner une aspirine « comme pour un infarctus ». Votre réponse ?',
        ['Oui, à croquer', 'NON — un AVC hémorragique serait aggravé : rien par la bouche', 'Oui, une demi-dose', 'Oui, avec de l’eau'], 1,
        'Impossible de distinguer ischémique/hémorragique au téléphone.'),
      Q('Position de la victime d’AVC consciente ?',
        ['À plat, jambes surélevées', 'Semi-assise, tête surélevée ~30°', 'Debout en marchant', 'Sur le ventre'], 1,
        'Semi-assise 30° — à ne pas confondre avec l’anaphylaxie (jambes surélevées).'),
      Q('Les symptômes disparaissent complètement. La famille veut annuler. Vous ?',
        ['Annulez — plus d’urgence', 'Maintenez : possible AIT, risque élevé d’AVC complet dans les heures qui suivent', 'Rétrogradez en P7', 'Recommandez le médecin de famille'], 1,
        'L’AIT est un signal d’alarme majeur : jamais annuler.'),
      Q('Symptômes découverts au réveil. Quelle heure retenez-vous ?',
        ['L’heure du réveil', 'La dernière heure où il a été VU normal (ex. : coucher la veille)', 'Midi par défaut', 'Aucune'], 1,
        '« Wake-up stroke » : heure de début inconnue → dernier moment vu normal.'),
      Q('Quel test complémentaire faites-vous faire par le proche ?',
        ['Prendre la température', 'Lever les DEUX bras : un bras qui retombe = signe positif', 'Toucher ses orteils', 'Compter jusqu’à 100'], 1,
        'Le « I » de VITE : incapacité — faiblesse d’un côté du corps.'),
      Q('Quelles questions d’antécédents sont pertinentes ?',
        ['Allergies alimentaires', 'Antécédents d’AVC, anticoagulants, chirurgie récente', 'Vaccins à jour', 'Dernière visite dentaire'], 1,
        'Anticoagulants et chirurgie récente : contre-indications possibles à la thrombolyse.'),
      Q('Un AVC chez une femme de 34 ans, c’est…',
        ['Impossible — trop jeune', 'Possible à tout âge : on ne banalise jamais (« juste une migraine »)', 'Toujours bénin', 'Une crise d’anxiété'], 1,
        'Le piège du jeune âge : un AVC peut survenir à tout âge.'),
    ],
  },

  reaction_allergique: {
    title: 'Auto-évaluation — Réaction allergique',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Critère téléphonique de l’ANAPHYLAXIE ?',
        ['Rougeurs seulement', 'Peau + AU MOINS 1 autre système (respiratoire, digestif, circulatoire)', 'Fièvre', 'Démangeaisons > 24 h'], 1,
        'Urticaire isolée = locale; peau + un autre système = anaphylaxie.'),
      Q('Traitement de PREMIÈRE ligne de l’anaphylaxie ?',
        ['Antihistaminique (Benadryl)', 'EpiPen (épinéphrine) sans délai', 'Eau froide', 'Aspirine'], 1,
        '« Attendre de voir si ça empire » est la phrase la plus dangereuse.'),
      Q('Consigne EpiPen correcte ?',
        ['Capuchon orange retiré, piquer le bras', 'Capuchon BLEU retiré, extrémité ORANGE sur la cuisse, maintenir ~3 s', 'Injecter au ventre', 'Faire avaler'], 1,
        'À travers les vêtements au besoin — « je compte avec vous : 1, 2, 3 ».'),
      Q('Position sans détresse respiratoire ?',
        ['Debout en marchant', 'Allongée, JAMBES SURÉLEVÉES', 'Assise penchée en avant', 'Sur le ventre'], 1,
        'Soutient la pression artérielle. Debout = risque de chute de pression.'),
      Q('La réaction biphasique, c’est…',
        ['Deux allergènes', 'Une récidive possible 1 à 8 h après l’amélioration → transport obligatoire', 'Deux membres atteints', 'Une réaction de deux jours'], 1,
        'L’amélioration n’annule JAMAIS le transport.'),
      Q('Aucune amélioration 5-10 minutes après l’EpiPen. Vous guidez…',
        ['Un antihistaminique', 'Une 2e dose d’épinéphrine si disponible', 'Un bain froid', 'Rien'], 1,
        'La 2e dose fait partie du protocole enseigné.'),
      Q('Quelle question ÉVITEZ-vous de poser (piège du code de nature) ?',
        ['« Gorge qui se ferme ? »', '« Avez-vous des problèmes respiratoires ? »', '« Partie du corps enflée ? »', '« Rougeurs, urticaire ? »'], 1,
        'La réponse risquerait de faire basculer vers la nature 6.'),
      Q('Voix rauque + difficulté à avaler après une exposition. Votre lecture ?',
        ['Simple mal de gorge', 'Atteinte des voies respiratoires (œdème du larynx) = priorité maximale', 'Déshydratation', 'Timidité'], 1,
        'La voix rauque est un drapeau rouge respiratoire majeur.'),
      Q('Piqûre d’abeille : main enflée jusqu’au poignet, respiration normale, phrases complètes, aucun autre signe. Votre lecture ?',
        ['Anaphylaxie : EpiPen', 'Réaction LOCALE : priorité moindre + consignes de surveillance', 'Urgence vitale', 'Rien à faire'], 1,
        'Locale vs systémique : le questionnement fait la différence de priorité.'),
      Q('Que surveillez-vous en attendant l’ambulance ?',
        ['La météo', 'Respiration, état de conscience, progression de l’enflure — rappel immédiat si détérioration', 'La tension artérielle au brassard', 'Rien'], 1,
        'Et on garde l’auto-injecteur utilisé pour les paramédics.'),
    ],
  },

  etouffement: {
    title: 'Auto-évaluation — Étouffement / Obstruction',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('La victime tousse encore fortement. Votre consigne ?',
        ['Heimlich immédiat', 'Encourager la toux — obstruction PARTIELLE', 'Donner de l’eau', 'Taper dans le dos'], 1,
        'Tant que la toux est efficace, on ne fait pas de manœuvre.'),
      Q('Silence complet + lèvres qui bleuissent ?',
        ['Amélioration', 'Obstruction COMPLÈTE : manœuvres immédiates, priorité maximale', 'Attendre 1 minute', 'Position latérale'], 1,
        'Le silence est le signal de bascule — pas un soulagement.'),
      Q('Où place-t-on le poing pour le Heimlich ?',
        ['Sur les côtes', 'Au-dessus du nombril, poussées vers le haut', 'Sur le sternum', 'Dans le bas du dos'], 1,
        'Derrière la victime, bras autour du ventre, poussées en « J » vers le haut.'),
      Q('Bébé de 9 mois qui s’étouffe ?',
        ['Heimlich comme l’adulte', '5 tapes dorsales + 5 compressions thoraciques en alternance', 'Doigts dans la bouche', 'Le secouer'], 1,
        'JAMAIS de Heimlich < 1 an — organes fragiles.'),
      Q('Pourquoi ne met-on JAMAIS les doigts à l’aveugle dans la bouche ?',
        ['C’est impoli', 'Risque d’enfoncer l’objet plus profondément', 'Risque de morsure seulement', 'Ça prend trop de temps'], 1,
        'On ne retire que ce qu’on VOIT.'),
      Q('La victime perd conscience pendant les manœuvres ?',
        ['Continuer le Heimlich debout', 'Basculer vers la RCR — les compressions peuvent déloger l’objet', 'Attendre les secours', 'La rasseoir'], 1,
        'La bascule étouffement → RCR est un incontournable.'),
      Q('Signe universel de l’étouffement ?',
        ['Bras levés au ciel', 'Mains à la gorge', 'Sautillements', 'Toux volontaire'], 1,
        'Les mains à la gorge : le signe reconnu internationalement.'),
      Q('Femme enceinte ou personne obèse qui s’étouffe ?',
        ['Heimlich abdominal standard', 'Compressions THORACIQUES au lieu d’abdominales', 'Aucune manœuvre', 'Tapes au ventre'], 1,
        'On adapte : poussées sur le thorax quand l’abdomen n’est pas accessible.'),
      Q('Taper dans le dos d’un adulte DEBOUT qui tousse ?',
        ['Toujours utile', 'À éviter : peut enfoncer l’objet — on encourage plutôt la toux', 'Obligatoire', 'Réservé aux enfants'], 1,
        'Le réflexe populaire est un piège tant que la toux est efficace.'),
      Q('L’objet est expulsé et la personne respire. Vous…',
        ['Raccrochez aussitôt', 'Recommandez l’évaluation (surtout après manœuvres) et documentez l’appel', 'Conseillez de manger doucement', 'Rien'], 1,
        'Après un Heimlich, une évaluation médicale est recommandée (lésions internes possibles).'),
    ],
  },

  inconscience: {
    title: 'Auto-évaluation — Inconscience / Évanouissement',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Inconsciente mais respiration NORMALE. Vos consignes ?',
        ['Compressions par précaution', 'Position latérale de sécurité + surveillance CONTINUE de la respiration', 'L’asseoir', 'Eau au visage'], 1,
        'PLS + surveillance : la situation peut basculer à tout moment.'),
      Q('« Respiration comme un poisson hors de l’eau » ?',
        ['Respiration normale', 'Respiration AGONALE = signe d’ACR → RCR immédiate', 'Hyperventilation', 'Ronflement'], 1,
        'LE piège n° 1 : les gasps ne sont pas une respiration.'),
      Q('Question spécifique pour une femme de 12 à 50 ans inconsciente ?',
        ['A-t-elle voyagé ?', 'A-t-elle des douleurs abdominales ?', 'Porte-t-elle des lentilles ?', 'A-t-elle déjeuné ?'], 1,
        'Question du protocole (grossesse ectopique possible).'),
      Q('Quel seuil d’âge fait partie du questionnement ?',
        ['18 ans', 'Plus ou moins de 35 ans', '65 ans', '50 ans seulement'], 1,
        'L’âge change la lecture du risque cardiaque.'),
      Q('Syncope : elle reprend conscience, confuse. Vos consignes ?',
        ['La faire marcher + jus sucré', 'Allongée, rien par la bouche, surveillance continue, ambulance maintenue', 'Annuler l’ambulance', 'L’asseoir au soleil'], 1,
        'Jamais rien par la bouche à un état de conscience altéré.'),
      Q('Évanouissement + antécédents cardiaques ?',
        ['Sans importance', 'Drapeau rouge : la priorité monte', 'Rassurant', 'On réfère au CLSC'], 1,
        'Syncope + cœur connu = combinaison à risque du protocole.'),
      Q('Changement de couleur de la peau ?',
        ['Détail cosmétique', 'Signe critique à questionner (pâleur, cyanose)', 'Sans lien', 'Normal après un repas'], 1,
        'La couleur de la peau fait partie du questionnement enseigné.'),
      Q('Elle cesse de respirer normalement pendant l’appel. Vos 2 premières consignes ?',
        ['Attendre et rappeler', 'Sur le dos, surface dure → compressions au centre du thorax, 100-120/min', 'PLS renforcée', 'Chercher le pouls'], 1,
        'Bascule PLS → RCR : le réflexe à maîtriser.'),
      Q('Peut-on donner de l’eau à une personne somnolente « pour la réveiller » ?',
        ['Oui, à petites gorgées', 'Non — risque d’étouffement : rien par la bouche', 'Oui, avec du sucre', 'Oui, si elle a soif'], 1,
        'Conscience altérée = plus rien par la bouche, point.'),
      Q('Quand raccrochez-vous ?',
        ['Dès l’ambulance affectée', 'Jamais avant l’arrivée des secours auprès de la victime', 'Après 5 minutes', 'Quand l’appelant est calme'], 1,
        'Vous êtes le moniteur de la victime jusqu’au relais.'),
    ],
  },

  difficulte_respiratoire: {
    title: 'Auto-évaluation — Difficulté respiratoire',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Meilleur indicateur téléphonique de la gravité ?',
        ['L’âge', 'La capacité de PAROLE : phrases complètes → mots isolés → silence', 'La toux', 'L’heure de l’appel'], 1,
        'La parole est votre thermomètre respiratoire.'),
      Q('Elle ne répond que par mots isolés ?',
        ['Détresse légère', 'Détresse SÉVÈRE : la priorité monte', 'Timidité', 'Fatigue normale'], 1,
        'Mots isolés = sévère; silence = pré-arrêt respiratoire.'),
      Q('Consigne de la pompe bleue (Ventolin) ?',
        ['Jamais sans médecin', '« Agitez votre pompe et insufflez le produit dans votre bouche »', 'Une fois par jour max', 'Debout seulement'], 1,
        'La procédure enseignée — sans attendre.'),
      Q('Victime silencieuse qui ne parle plus du tout ?',
        ['Amélioration', 'Épuisement respiratoire, arrêt imminent → P1', 'Elle dort', 'Elle boude'], 1,
        'Le silence est le stade le plus grave, pas un mieux.'),
      Q('Quelles questions du protocole posez-vous ?',
        ['Sifflement ? Difficulté à parler ? Couleur de la peau ? Asthme ?', 'Dernier repas ? Allergies alimentaires ?', 'Sommeil ? Stress ?', 'Groupe sanguin ?'], 0,
        'Sifflement, parole, coloration, antécédents d’asthme : le quatuor enseigné.'),
      Q('Éruption cutanée + difficulté respiratoire ?',
        ['Nature 6 confirmée', 'Penser protocole 2 (réaction allergique)', 'Coup de chaleur', 'Grippe'], 1,
        'La bascule de protocole classique : allergie déguisée.'),
      Q('Position pour une personne en détresse respiratoire consciente ?',
        ['À plat sur le dos', 'Assise ou semi-assise, au repos', 'Jambes surélevées', 'Sur le ventre'], 1,
        'La position assise facilite la respiration.'),
      Q('La personne veut aller prendre l’air dehors seule ?',
        ['Bonne idée', 'Non : elle reste accompagnée et surveillée — risque de perte de conscience', 'Oui, en marchant vite', 'Oui, aux toilettes'], 1,
        'Jamais laisser s’isoler une personne en détresse.'),
      Q('Asthmatique connue SANS sa pompe ?',
        ['On attend', 'Ambulance prioritaire + position assise + calme + surveillance de la parole', 'On envoie chercher une pompe au dépanneur', 'On raccroche'], 1,
        'Sans médication, la surveillance et la rapidité priment.'),
      Q('Elle cesse de respirer. Votre bascule ?',
        ['PLS', 'RCR guidée immédiatement', 'Attendre 2 minutes', 'Eau froide'], 1,
        'Arrêt respiratoire → protocole d’arrêt : compressions sans délai.'),
    ],
  },

  noyade: {
    title: 'Auto-évaluation — Noyade / Plongeon',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Vos DEUX premières questions ?',
        ['Sait-elle nager ? L’eau est-elle froide ?', 'Est-elle HORS DE L’EAU ? Respire-t-elle normalement ?', 'Depuis quand la piscine ?', 'Y a-t-il un sauveteur ?'], 1,
        'Sortir de l’eau + évaluer la respiration : tout part de là.'),
      Q('Elle ne respire plus ?',
        ['Attendre que l’eau sorte', 'Basculer au protocole 9 (ACR) — si possible 5 insufflations initiales', 'La suspendre par les pieds', 'La réchauffer d’abord'], 1,
        'La cause est le manque d’oxygène : les insufflations initiales priment.'),
      Q('Particularité du DEA après une noyade ?',
        ['Interdit', 'Sécher la poitrine et éloigner la victime de l’eau avant les électrodes', 'Le brancher sous l’eau', 'Attendre 10 minutes'], 1,
        'Peau NUE et SÈCHE, victime hors de l’eau : le DEA reste pleinement indiqué.'),
      Q('Plongeon en eau peu profonde : quelle question clé ?',
        ['La marque du maillot', 'Blessures à la TÊTE ou au cou ?', 'La température de l’eau', 'L’heure du dîner'], 1,
        'Trauma crânien/cervical possible : on questionne et on limite les mouvements.'),
      Q('Plongée sous-marine (SCUBA) : quel danger enseigné ?',
        ['Les méduses', 'La remontée trop rapide = mal des caissons', 'Le soleil', 'Les crampes'], 1,
        'Les étapes de remontée doivent être respectées.'),
      Q('Enfant sorti de l’eau, conscient, qui tousse et vomit de l’eau ?',
        ['Aucun suivi requis', 'Ambulance recommandée : détérioration respiratoire possible dans les heures qui suivent', 'Retour à la baignade', 'Juste une serviette'], 1,
        'Après une quasi-noyade, la surveillance médicale s’impose.'),
      Q('Victime inconsciente qui respire, hors de l’eau ?',
        ['Debout', 'Position latérale de sécurité + surveillance continue', 'Assise', 'Compression immédiate'], 1,
        'PLS — et bascule RCR si la respiration devient anormale.'),
      Q('Que rappelez-vous à l’appelant AVANT le sauvetage ?',
        ['Rien', 'Sa propre sécurité : ne pas devenir la 2e victime (perche, objet flottant)', 'De filmer', 'De crier'], 1,
        'La sécurité du sauveteur improvise fait partie de vos consignes.'),
      Q('Hypothermie possible après une immersion prolongée : vous…',
        ['Frictionnez vigoureusement', 'Retirez les vêtements mouillés et couvrez — manipulation DOUCE', 'Bain chaud immédiat', 'Alcool pour réchauffer'], 1,
        'Manipulation douce (cœur froid = instable) et réchauffement progressif.'),
      Q('Priorités possibles de la nature 14 (noyade) ?',
        ['P7 seulement', 'P0, 1, 3 ou 7', 'P2 et 5', 'P4 seulement'], 1,
        'De l’ACR au conseil : le questionnement fixe la priorité.'),
    ],
  },

  convulsions: {
    title: 'Auto-évaluation — Convulsions / Épilepsie',
    description: '10 questions pour valider votre compréhension du protocole. Seuil de réussite : 70 %.',
    questions: [
      Q('Que fait-on PENDANT la convulsion ?',
        ['Immobiliser la personne de force', 'Protéger sa tête, éloigner les objets, ne RIEN mettre dans sa bouche', 'Lui tenir la langue', 'La doucher'], 1,
        'On protège sans retenir; jamais d’objet dans la bouche.'),
      Q('Pourquoi ne met-on rien dans la bouche ?',
        ['Question d’hygiène', 'Risque d’étouffement et de blessure — le mythe d’« avaler sa langue » est faux', 'Ça coûte cher', 'Pour entendre'], 1,
        'On ne peut pas avaler sa langue : le mythe cause des blessures.'),
      Q('Après la convulsion, la personne respire mais reste inconsciente ?',
        ['L’asseoir', 'Position latérale de sécurité + surveiller la respiration', 'La faire boire', 'La secouer'], 1,
        'Phase post-critique : PLS et surveillance.'),
      Q('Quelles questions du protocole ?',
        ['Plus/moins de 35 ans ? Enceinte ? Diabète ? Antécédents (épilepsie, AVC) ?', 'Repas ? Sport ?', 'Voyage ? Vaccins ?', 'Sommeil ? Café ?'], 0,
        'Âge, grossesse, diabète et antécédents : le questionnement enseigné.'),
      Q('Pourquoi demander « faites-vous du diabète ? » ?',
        ['Par curiosité', 'L’hypoglycémie sévère peut provoquer des convulsions', 'Pour la facturation', 'Aucun lien'], 1,
        'Le cerveau privé de sucre peut convulser.'),
      Q('Femme enceinte qui convulse ?',
        ['Priorité normale', 'Situation critique (éclampsie possible) : priorité élevée', 'Référer au médecin', 'Attendre la fin'], 1,
        'La grossesse fait partie des questions car l’éclampsie est une urgence vitale.'),
      Q('Convulsion qui ne s’arrête PAS (ou s’enchaîne sans réveil) ?',
        ['Normal', 'État de mal épileptique : urgence vitale, priorité maximale', 'Attendre 30 minutes', 'Fatigue passagère'], 1,
        'Une convulsion prolongée est une urgence à part entière.'),
      Q('Épileptique connu, crise typique terminée, réveil progressif ?',
        ['P0 automatique', 'Le questionnement (durée, blessure, récupération) module la priorité', 'Toujours P7', 'Police requise'], 1,
        'Antécédents connus + récupération normale ≠ même urgence qu’une première crise.'),
      Q('Que documentez-vous pour les ambulanciers ?',
        ['La couleur des murs', 'Durée de la crise, description des mouvements, blessures (tête), médicaments', 'Le menu du souper', 'Rien'], 1,
        'La durée et la description guident le traitement.'),
      Q('Chez les moins de 35 ans, que retenir de la théorie ?',
        ['Aucun risque', 'La fatalité est plus probable — l’âge change la lecture du risque', 'Toujours bénin', 'Uniquement le stress'], 1,
        'La règle des 35 ans vue en classe (nature 12).'),
    ],
  },
};
